"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

const TermsContent = ({ data }: { data?: any }) => {
  const pathname = usePathname();

  const getActiveClass = (href: string) => {
    return pathname === href ? "active" : "";
  };

  return (
    <Tabs>
      <div className="row y-gap-30">
        {/* <div className="col-lg-3">
          <div className="px-30 py-30 rounded-4 border-light">
            <TabList className="tabs__controls row y-gap-10 js-tabs-controls">
              <Tab
                className={`col-12 tabs__button js-tabs-button ${getActiveClass(
                  "/legal-notice"
                )}`}
              >
                <Link href="/legal-notice">Legal Notice</Link>
              </Tab>
              <Tab
                className={`col-12 tabs__button js-tabs-button ${getActiveClass(
                  "/privacy-policy"
                )}`}
              >
                <Link href="/privacy-policy">Privacy Policy</Link>
              </Tab>
              <Tab
                className={`col-12 tabs__button js-tabs-button ${getActiveClass(
                  "/terms-and-conditions"
                )}`}
              >
                <Link href="/terms-and-conditions">Terms & Conditions</Link>
              </Tab>
            </TabList>
          </div>
        </div> */}
        {/* End .col-lg-3 */}

        <div className="col-lg-12">
          <TabPanel>
            <div className="tabs__content js-tabs-content" data-aos="fade">
              <p
                className="text-15 text-dark-1 mt-5"
                dangerouslySetInnerHTML={{ __html: data?.content }}
              ></p>
            </div>
          </TabPanel>
          {/* End General Terms of Use */}
        </div>
        {/* End col-lg-9 */}
      </div>
    </Tabs>
  );
};

export default TermsContent;
